import React from 'react';

import FeaturesList from 'bundle-loader?lazy&name=home!./components/routes/features/featuresList/featureList.jsx';
import AddFeature from 'bundle-loader?lazy&name=home!./components/routes/features/addOrEdit/addFeature.jsx';
// import EditMarketList from 'bundle-loader?lazy&name=home!./components/routes/marketplace/editMarket/editMarketList.jsx';

export const GOLD_COMPANY_ID = '00000000-0000-0000-0000-000000000000';

const params = {
    uuid: ( paramName ) =>
        `${
            paramName ? ':' + paramName : ''
        }([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})`,
    // ...
};
export const COMPANY_ID = params.uuid( 'companyId' );
const Bundle = ( Component ) => ( props ) => <Component { ...props } />;
export const routes = [
    {
        title: 'Features',
        pattern: `/${ COMPANY_ID }`,
        load: FeaturesList,
    },
    {
        title: ' Add/Edit Feature ',
        pattern: `${ COMPANY_ID }/features/:id?`,
        load: AddFeature,
    }
    // {
    //     title: ' Edit MarketPlace ',
    //     pattern: `${ GOLD_COMPANY_ID }/marketPlace/editMarket/:id`,
    //     load: EditMarketList,
    // },
];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;

    if ( match && !match.render && typeof match.load === 'function' ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ? asyncModule.default : asyncModule,
                match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}

export const replacePatternVars = ( pattern, vars ) => {
    const PATTERN_DELIMITER = '/';
    const pathTokens = ( pattern || '' )
        .split( PATTERN_DELIMITER )
        .filter( ( token ) => !!token );
    const resolvedTokens = [];

    // Attempt to resolve all tokens in the
    for ( let i = 0; i < pathTokens.length; i++ ) {
        const token = pathTokens[ i ];
        const PATTERN_PARAM = /^:[a-zA-Z0-9]+/g;
        const paramMatches = ( token || '' ).match( PATTERN_PARAM );

        // If there is a parameter in the token and a matching value, replace the token.
        if ( paramMatches && paramMatches.length > 0 ) {
            const match = paramMatches[ 0 ];
            const paramName = match.substring( 1 );

            const value = vars[ paramName ];
            if ( value !== null && value !== undefined ) {
                resolvedTokens.push( value );
                continue;
            }
        }

        // If the token hasn't already been replaced, leave the token as is.
        resolvedTokens.push( token );
    }

    return PATTERN_DELIMITER + resolvedTokens.join( PATTERN_DELIMITER );
};

export const redirectMiddleware = [
    ( action, nextRoute, prevRoute ) => {
        if ( nextRoute.pathname === '/' ) {
            return action.redirect( `/${ GOLD_COMPANY_ID }` );
        } else {
            return action.ok();
        }
    },
];
